import listActions from '../../../modules/courseCategory/list/courseCategoryListActions'
import CourseCategoryService from '../../../modules/courseCategory/courseCategoryService'
import Errors from '../../../modules/shared/error/errors'
import { i18n } from '../../../i18n'
import { push } from 'redux-first-history'
import Message from '../../../view/shared/message'

const prefix = 'COURSECATEGORY_DESTROY'

const courseCategoryDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: courseCategoryDestroyActions.DESTROY_STARTED,
      })

      await CourseCategoryService.destroyAll([id])

      dispatch({
        type: courseCategoryDestroyActions.DESTROY_SUCCESS,
      })

      Message.success(
        i18n('entities.courseCategory.destroy.success'),
      )

      dispatch(listActions.doFetchCurrentFilter())

      dispatch(push('/course-category'))
    } catch (error) {
      Errors.handle(error)

      dispatch(listActions.doFetchCurrentFilter())

      dispatch({
        type: courseCategoryDestroyActions.DESTROY_ERROR,
      })
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: courseCategoryDestroyActions.DESTROY_ALL_STARTED,
      })

      await CourseCategoryService.destroyAll(ids)

      dispatch({
        type: courseCategoryDestroyActions.DESTROY_ALL_SUCCESS,
      })

      if (listActions) {
        dispatch(listActions.doClearAllSelected())
        dispatch(listActions.doFetchCurrentFilter())
      }

      Message.success(
        i18n('entities.courseCategory.destroyAll.success'),
      )

      dispatch(push('/course-category'))
    } catch (error) {
      Errors.handle(error)

      dispatch(listActions.doFetchCurrentFilter())

      dispatch({
        type: courseCategoryDestroyActions.DESTROY_ALL_ERROR,
      })
    }
  },
}

export default courseCategoryDestroyActions
